import { render, staticRenderFns } from "./Z-5_Selection.vue?vue&type=template&id=489d3802&"
import script from "./Z-5_Selection.vue?vue&type=script&lang=js&"
export * from "./Z-5_Selection.vue?vue&type=script&lang=js&"
import style0 from "./Z-5_Selection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
installComponents(component, {VAutocomplete,VChip,VCombobox})
